import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { USER_INVITE_FRAGMENT } from 'src/graphql/user/schema';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationAddCustomerUserArgs, BackendUserInvite } from 'src/types/backend';

const MUTATION = gql`
  mutation AddCustomerUser(
    $customerId: ID!
    $email: String!
    $name: String
    $defaultWorkspaceId: ID
  ) {
    addCustomerUser(
      customerId: $customerId
      email: $email
      name: $name
      defaultWorkspaceId: $defaultWorkspaceId
    ) {
      ...UserInvite
    }
  }
  ${USER_INVITE_FRAGMENT}
`;

type Variables = BackendMutationAddCustomerUserArgs;
type Result = BackendUserInvite;

export const addCustomerUser = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
